import React, {useState} from 'react';
import {Flex} from "antd";
import {StyledCard} from "./DetailCards.styled";
import style from "./DetailCards.module.scss";
import {
    LeftOutlined
} from '@ant-design/icons';
import {PiCubeFocusFill} from "react-icons/pi";
import StorageAndDeliveryConditionPopUp from "../StorageAndDeliveryConditionPopUp/StorageAndDeliveryConditionPopUp";
import {StorageAndDeliveryConditionsCardProps} from "../../../models";

const StorageAndDeliveryConditionsCard = ({product} : StorageAndDeliveryConditionsCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const openStorageAndDeliveryConditionsModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }
    return (
        <>
            <StyledCard className={'shadow-sm'} onClick={openStorageAndDeliveryConditionsModal}  >
                <Flex justify={"space-between"} align={"center"}>
                    <Flex gap={"middle"}>
                        <span> <PiCubeFocusFill className={style.icons}/> شرایط نگهداری و تحویل محصول </span>
                    </Flex>
                    <Flex gap={"small"}>
                        <span className={style.greyText}>{product?.productConditions?.flatMap((x : any) => x.detail).length} مورد</span>
                        <span> <LeftOutlined className={style.icons}/> </span>

                    </Flex>

                </Flex>
            </StyledCard>
            <StorageAndDeliveryConditionPopUp product={product} open={open} onCansel={onCansel}/>
        </>
    );
};

export default StorageAndDeliveryConditionsCard;
